import React from 'react';

import useBoard from '@/use/useBoard';

import Border from './Border';
import Grid from './Grid';

const Board = () => {
  const { x, y } = useBoard();

  return (
    <pixiContainer x={x} y={y}>
      <Border />
      <Grid />
    </pixiContainer>
  );
};

export default Board;
